/* eslint-disable id-length */
import React from 'react';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
} from '@mui/material';
import PropTypes from 'prop-types';

const CertificationTable = ({
  targetData,
  handleAchievedClick,
  calculateTotals,
  selectedYear,
}) => {

  const navigateToQuarterMap = (index, target) => {
    const { currentQuarterAchieved, quarter } = target;
    if (currentQuarterAchieved > 0) {
      handleAchievedClick(index, quarter, selectedYear);
    }
  };

  const renderTableRows = () => {
    const quarters = [
      'Q1(Jan - Mar)',
      'Q2(Apr - Jun)',
      'Q3(Jul - Sep)',
      'Q4(Oct - Dec)',
    ];
    const rows = [];
    const { totalTarget, totalAchieved, totalOverachieved, totalPending }
      = calculateTotals();
    rows.push(
      <TableRow key="target">
        <TableCell>Target</TableCell>
        <TableCell className="total-column">{totalTarget}</TableCell>
        {quarters.map((quarter) => {
          // eslint-disable-next-line id-length
          const target = targetData.find((t) => t.quarter === quarter);
          return (
            <TableCell key={quarter}>
              {target?.currentQuarterTarget || 0}
            </TableCell>
          );
        })}
      </TableRow>,
    );

    rows.push(
      <TableRow key="achieved">
        <TableCell>Achieved</TableCell>
        <TableCell
          className="total-column"
          onClick={() => {
            if (totalAchieved > 0) {
              handleAchievedClick(null, 'yearly', selectedYear);
            }
          }}
          style={{ cursor: totalAchieved > 0 ? 'pointer' : 'default' }}
        >
          {totalAchieved}
        </TableCell>
        {quarters.map((quarter, index) => {
          const target = targetData.find((t) => t.quarter === quarter);
          return (
            <TableCell
              key={quarter}
              onClick={() => navigateToQuarterMap(index, target)}
            >
              <span style={{ cursor: 'pointer' }}>
                {target?.currentQuarterAchieved}
              </span>
            </TableCell>
          );
        })}
      </TableRow>,
    );


    rows.push(
      <TableRow key="overachieved">
        <TableCell>Overachieved</TableCell>
        <TableCell className="total-column">{totalOverachieved}</TableCell>
        {quarters.map((quarter) => {
          const target = targetData.find((t) => t.quarter === quarter);
          return (
            <TableCell key={quarter}>
              <span>{target?.currentQuarterOverachieved}</span>
            </TableCell>
          );
        })}
      </TableRow>,
    );


    rows.push(
      <TableRow key="pending">
        <TableCell>Pending</TableCell>
        <TableCell className="total-column">{totalPending}</TableCell>
        {quarters.map((quarter) => {
          const target = targetData.find((t) => t.quarter === quarter);
          return (
            <TableCell key={quarter}>
              {target?.currentQuarterPending || 0}
            </TableCell>
          );
        })}
      </TableRow>,
    );

    return rows;
  };

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow className="nowrap">
            <TableCell>Yearly</TableCell>
            <TableCell className="total-column">Total</TableCell>
            <TableCell>Q1(Jan - Mar)</TableCell>
            <TableCell>Q2(Apr - Jun)</TableCell>
            <TableCell>Q3(July - Sep)</TableCell>
            <TableCell>Q4(Oct - Dec)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {targetData && renderTableRows()}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

CertificationTable.propTypes = {
  targetData: PropTypes.arrayOf(
    PropTypes.shape({
      quarter: PropTypes.string.isRequired,
      currentQuarterTarget: PropTypes.number,
      currentQuarterAchieved: PropTypes.number.isRequired,
      currentQuarterOverachieved: PropTypes.number.isRequired,
      uniqueAchievedCount: PropTypes.number.isRequired,
      currentQuarterPending: PropTypes.number,
    }),
  ).isRequired,
  handleAchievedClick: PropTypes.func.isRequired,
  calculateTotals: PropTypes.func.isRequired,
  selectedYear: PropTypes.number.isRequired,
};

export default CertificationTable;
